import { useMutation } from "@tanstack/react-query";
import { api } from "@utils/api";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

export const useStartPasswordlessOnboarding = () => {
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (startData: any) => api.post(`onboarding/start`, startData),
    onError: (res: any) => {
      console.error("[From Start Passwordless Onboarding]", res);
      handleErrors(res, "mutation");
    },
  });
};
